import packingRequest from '../request/packing'
import createApiServices from './createApiServices'
import { extendUrlFulfillment } from '../../views/helpers/extenent-url'

const apiRequest = packingRequest()

const labelApi = createApiServices({
    baseUrl: `${extendUrlFulfillment.url}/api`
})

export const getListCombineShip = async (args = {}) => {
    const {data} = await apiRequest({
        url: '/packing/barcode-combine-ship/get-list',
        method: 'POST',
        data: args
    })

    return data
}

export const genLabelCombineShip = (orderId, factory = '1C') => {
    return labelApi.makeAuthRequest({
        url: `/label/combine-ship/${orderId}/${factory}/generate-label`,
        method: 'POST',
    })
}

export const getCombineShipDetails = (id) => {
    return apiRequest({
        url: `/packing/barcode-combine-ship/${id}`,
        method: 'GET',
    })
}

export const createCombineShip = (data) => {
    return apiRequest({
        url: `/packing/barcode-combine-ship`,
        method: 'POST',
        data: data,
    })
}

export const updateCombineShip = (id,data) => {
    return apiRequest({
        url: `/packing/barcode-combine-ship/${id}`,
        method:'PUT',
        data: data,
    })
}
